import { useState } from "react";
import { useSnackbar } from "notistack";

// Hook to copy text to clipboard with a state to indicate if the copy was successful or not that lasts for 1 seconds.

const useCopy = (cooldown?: number) => {
  const { enqueueSnackbar } = useSnackbar();
  // Props
  const delay = cooldown || 1000;
  // State
  const [isCopied, setIsCopied] = useState(false);
  // Event handlers
  const copy = (text: string) => {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error("Failed to copy to clipboard: ", err);
      enqueueSnackbar("Failed to copy to clipboard", { variant: "error" });
    });
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, delay);
  };
  // Return
  return [isCopied, copy] as const;
};

export default useCopy;
